<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-container class="px-6">
    <v-progress-linear
      v-if="loading"
      color="primary"
      indeterminate
    />
    <page-header>{{ $t('menu') }}</page-header>
    <div class="text-body-1 mb-6">
      {{ $t('introduceOfMenu') }}
    </div>
    <div style="display: grid;grid-template-columns: repeat(4,minmax(0,1fr));grid-gap: 24px">
      <consume-type-info-card
        v-for="(c,i) in consumeTypeList"
        :key="c.id"
        :consume-type-id="c.id"
        :consume-type-info="c"
        @click="startEditConsumeType(i)"
        @copy="copyMenu(c)"
        @delete="deleteAndReload(c.id)"
        @dish-click="setDishFor(c.id)"
        @time-click="setTimeFor(c.id)"
        @price-click="setDishPriceFor(c.id)"
        @setting-click="startEditConsumeTypeSetting(c.id)"
      />
      <v-card
        class="pa-4 d-flex align-center justify-center"
        color="#eee"
        elevation="0"
        height="360"
        @click="startEditConsumeType(-1)"
      >
        <div class="text-center">
          <v-icon size="48">
            mdi-plus
          </v-icon>
          <div>
            {{ $t('addNewMenu') }}
          </div>
        </div>
      </v-card>
    </div>

    <nice-dialog v-model="showTimeDialog">
      <ik-data-table
        v-if="showTimeDialog"
        :entity-name="$t('timeSetting')"
        :filter="filter"
        :fixed-filter="filter"
        :model="buffetTimeSpanModel"
        icon="mdi-account-child"
        @reload="reload"
      >
        <template
          #navigation
        >
          <back-button @close="showTimeDialog=false"/>
        </template>
      </ik-data-table>
    </nice-dialog>
    <nice-dialog v-model="showDishPriceDialog">
      <buffet-price-dish-fragment :consume-type-id="activeConsumeTypeIndex"/>
    </nice-dialog>
    <nice-dialog
      v-model="showDishDialog"
      width="max(700px,min(calc(100vw - 300px),300px))"
    >
      <div>
        <show-dish-card :filter="filter"/>
      </div>
    </nice-dialog>

    <ik-entity-form
      v-model="showConsumeTypeDialog"
      :edited-index="activeConsumeTypeIndex"
      :model="ConsumeType"
      :out-side-list="consumeTypeList"
      :title="$t('menu')"
      @need-refresh="reload"
    />
    <ik-entity-form
      v-model="showConsumeSettingDialog"
      :edited-index="realSettingIndex"
      :model="BuffetSetting"
      :out-side-list="consumeSettingList"
      :out-side-property="filter"
      :show-add-more-button="false"
      :title="$t('dinnerSet')"
      @need-refresh="reload"
    />
    <v-dialog
      v-model="copySchedule"
      max-width="400px"
      persistent
    >
      <v-card>
        <div
          class="pa-4 py-6 text-center"
        >
          <div class="text-h3">
            {{ $t('copyMenuNow') }}
          </div>
          <div
            class="text-body-1 mt-2"
            v-html="log"
          />
          <div
            v-if="finishedDishCount === copyDishList.length"
            class="mt-2"
          >
            <v-icon
              color="success"
              left
            >
              mdi-check
            </v-icon>
            {{ $t('copy_success_close_after_2_seconds') }}
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { IkDataTable, IkEntityForm } from 'metaflow-js'
  import BuffetSetting from '@/model/buffet/BuffetSetting'
  import ConsumeType from '@/model/buffet/ConsumeType'
  import BuffetTimeSpan from '@/model/buffet/BuffetTimeSpan'
  import BuffetPrice from '@/model/buffet/BuffetPrice'
  import NiceDialog from '@/composable/InK/NiceDialog'
  import BackButton from '@/composable/InK/BackButton'
  import PageHeader from '@/composable/InK/typography/PageHeader'
  import ConsumeTypeInfoCard from '@/views/AadenPages/dishes/dish-display/widget/ConsumeTypeInfoCard'
  import BuffetPriceDishFragment from '@/views/AadenPages/dishes/dish-display/widget/BuffetPriceDishFragment'
  import ShowDishCard from '@/views/AadenPages/dishes/dish-display/widget/ShowDishCard'
  import DishesConsumeType from '@/model/buffet/DishesConsumeType'

  export default {
    components: {
      // AddDishes,
      // UploadDishPage,
      ShowDishCard,
      BuffetPriceDishFragment,
      ConsumeTypeInfoCard,
      PageHeader,
      BackButton,
      NiceDialog,
      IkDataTable,
      IkEntityForm,
    },
    data: function () {
      return {
        loading: false,
        log: '',
        menuCopy: [],
        finishedDishCount: null,
        finishedBuffetSettingCount: null,
        finishedPriceCount: null,
        finishedTimeCount: null,
        copyDishList: [],
        copySchedule: null,
        tab: 0,
        // BuffetChild: BuffetChild,
        BuffetSetting: BuffetSetting,
        ConsumeType: ConsumeType,
        showTimeDialog: false,
        showDishDialog: false,
        showDishPriceDialog: false,
        buffetTimeSpanModel: BuffetTimeSpan,
        buffetPriceModel: BuffetPrice,
        activeConsumeTypeIndex: null,
        showConsumeTypeDialog: null,
        consumeTypeList: [],
        showConsumeSettingDialog: null,
        consumeSettingList: [],
        showList: [],
        showUploadDishDialog: false,
      }
    },
    computed: {
      filter: function () {
        return this.activeConsumeTypeIndex ? { consumeTypeId: this.activeConsumeTypeIndex } : { consumeTypeId: 1 }
      },
      realSettingIndex: function () {
        return this.consumeSettingList.findIndex(it => it.consumeTypeId === this.activeConsumeTypeIndex)
      },
    },
    watch: {
      showDishDialog (val) {
        if (!val) {
          this.reload()
        }
      },
      showTimeDialog (val) {
        if (!val) {
          this.reload()
        }
      },
      showDishPriceDialog (val) {
        if (!val) {
          this.reload()
        }
      },
    },
    mounted () {
      this.reload()
    },
    methods: {
      closeDialog () {
        this.copySchedule = false
        this.reload()
      },
      async copyMenu (c) {
        this.copySchedule = true
        c.langs.forEach(function (value) {
          switch (value.lang) {
            case 'DE':
              value.name += 'Kopie'
              break
            case 'ZH':
              value.name += '复制品'
              break
            case 'EN':
              value.name += 'Copy'
              break
          }
        })
        this.log = ''
        this.finishedDishCount = 0
        this.finishedPriceCount = 0
        this.finishedTimeCount = 0
        this.finishedBuffetSettingCount = 0
        this.log += '<div>' + this.$t('start_create_menu') + '</div>'
        this.activeConsumeTypeIndex = c.id
        this.copyDishList = (await DishesConsumeType.getList(true, this.filter)).filter(item => item.showing === true)
        try {
          this.menuCopy = await ConsumeType.add(c)
          this.log += this.$t('create_menu_successfully') + '<br>'
        } catch (e) {
          this.log += this.$t('failed_to_create_menu') + '<br>'
          return
        }
        this.getBuffetSetting = (await BuffetSetting.getList(true)).filter(a => a.consumeTypeId === c.id)
        this.priceList = (await BuffetPrice.getList(true)).filter(b => b.consumeTypeId === c.id)
        this.timeList = (await BuffetTimeSpan.getList(true, this.filter)).filter(d => d.consumeTypeId === c.id)
        // 可用时间
        try {
          for (const item of this.timeList) {
            item.consumeTypeId = parseInt(this.menuCopy.content[0].id)
            await BuffetTimeSpan.add(item)
            this.finishedTimeCount++
            this.log += this.$t('copying_time_setting') + this.finishedTimeCount + '/' + this.timeList.length + '<br>'
            if (this.finishedTimeCount !== this.timeList.length + 1) {
              this.log = this.log.replace(this.$t('copying_time_setting') + (this.finishedTimeCount - 1) + '/' + this.timeList.length + '<br>', ' ')
            }
          }
        } catch (e) {
          this.failedTimeCopy = this.failedTimeCopy + 1
          this.log += this.$t('failed') + this.failedPriceCopy + this.$t('a')
        }
        // 自助价格
        try {
          for (const item of this.priceList) {
            item.consumeTypeId = parseInt(this.menuCopy.content[0].id)
            item.code = item.code + item.consumeTypeId
            await BuffetPrice.add(item)
            this.finishedPriceCount = this.finishedPriceCount + 1
            this.log += this.$t('copying_price_setting') + this.finishedPriceCount + '/' + this.priceList.length + '<br>'
            if (this.finishedPriceCount !== this.priceList.length + 1) {
              this.log = this.log.replace(this.$t('copying_price_setting') + (this.finishedPriceCount - 1) + '/' + this.priceList.length + '<br>', ' ')
            }
          }
        } catch (e) {
          this.failedPriceCopy = this.failedPriceCopy + 1
          this.log += this.$t('failed') + this.failedPriceCopy + this.$t('a')
        }
        // 包餐设置
        try {
          for (const item of this.getBuffetSetting) {
            item.consumeTypeId = parseInt(this.menuCopy.content[0].id)
            await BuffetSetting.add(item)
            this.finishedBuffetSettingCount = this.finishedBuffetSettingCount + 1
            this.log += this.$t('copying_buffet_setting') + this.finishedBuffetSettingCount + '/' + this.getBuffetSetting.length + '<br>'
            if (this.finishedBuffetSettingCount !== this.getBuffetSetting.length + 1) {
              this.log = this.log.replace(this.$t('copying_buffet_setting') + (this.finishedBuffetSettingCount - 1) + '/' + this.getBuffetSetting.length + '<br>', ' ')
            }
          }
        } catch (e) {
          this.failedPriceCopy = this.failedPriceCopy + 1
          this.log += this.$t('failed') + this.failedPriceCopy + this.$t('a')
        }
        // 商品中的商品
        try {
          for (const item of this.copyDishList) {
            item.consumeTypeId = parseInt(this.menuCopy.content[0].id)
            await DishesConsumeType.edit(item)
            this.finishedDishCount = this.finishedDishCount + 1
            this.log += this.$t('copying_product_setting') + this.finishedDishCount + '/' + this.copyDishList.length + '<br>'
            if (this.finishedDishCount !== this.copyDishList.length + 1) {
              this.log = this.log.replace(this.$t('copying_product_setting') + (this.finishedDishCount - 1) + '/' + this.copyDishList.length + '<br>', ' ')
            }
          }
        } catch (e) {
          this.failedDishCopy = this.failedDishCopy + 1
          this.log += this.$t('failed') + this.failedPriceCopy + this.$t('a')
        }
        setTimeout(() => {
          this.closeDialog()
        }, 2000)
      },
      startEditConsumeTypeSetting (id) {
        this.showConsumeSettingDialog = true
        this.activeConsumeTypeIndex = id
      },
      startEditConsumeType (index) {
        this.showConsumeTypeDialog = true
        this.activeConsumeTypeIndex = index
      },
      setTimeFor (id) {
        this.showTimeDialog = true
        this.activeConsumeTypeIndex = id
      },
      setDishPriceFor (id) {
        this.showDishPriceDialog = true
        this.activeConsumeTypeIndex = id
      },
      setDishFor (id) {
        this.showDishDialog = true
        this.activeConsumeTypeIndex = id
      },
      async deleteAndReload (id) {
        await ConsumeType.remove(id)
        await this.reload()
      },
      async reload () {
        this.loading = true
        this.consumeTypeList = (await ConsumeType.getList(true))

        this.consumeSettingList = (await BuffetSetting.getList(true)).filter(it => ![3, 4].includes(it.id))
        this.loading = false
      },
    },
  }
</script>
